<template>
	<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
		<title>Icon_plus</title>
		<desc>Created with Sketch.</desc>
		<g id="Visual-Design" stroke="none" stroke-width="1" fill="none"
			fill-rule="evenodd">
			<g id="S30-Open-Large-Menu" transform="translate(-322.000000, -234.000000)"
				fill="#231F20" fill-rule="nonzero">
				<g id="Group-7-Copy-6" transform="translate(159.000000, 213.000000)">
					<g id="Group-6">
						<g id="Group-7-Copy-3"
							transform="translate(149.000000, 7.000000)">
							<g id="Group-6">
								<path
									d="M20,20 L20,14 L24,14 L24,20 L30,20 L30,24 L24,24 L24,30 L20,30 L20,24 L14,24 L14,20 L20,20 Z"
									id="Icon_plus"></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>																											
</template>

<script>
export default {
	name: "SvgIconPlus"
};
</script>